import React from 'react';
import About from './Components/About';
import Agent from './Components/Agent';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import Header from './Components/Header';
import Howitwork from './Components/Howitwork';
import Properties from './Components/Properties';

/*Developed for Rapsol Technologies as Assignment by:Chrisbin Thomas*/

function App() {
  return (
    <div className="App">
      <Header/>
      <Howitwork/>
      <About/>
      <Agent/>
      <Properties/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
